import { BaseDTO } from '../global/base.dto';
import { UserListDTO } from '../user/user-list.dto';
import { TradeRequestEventListDTO } from './trade-request-event-list.dto';
import { TradeRequestOfferListDTO } from './trade-request-offer-list.dto';

export class TradeRequestDTO extends BaseDTO {
    
    pending: boolean;

    event: TradeRequestEventListDTO;

    user: UserListDTO;

    offers: Array<TradeRequestOfferListDTO>;

}
